exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rainbow-container {\n  text-align: center; }\n  .rainbow-container img {\n    max-width: 85px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/control/control.component.scss
// module id = 206
// module chunks = 1